export default __webpack_public_path__ + "static/media/boardwalk-concept-2400x1350.1bfdafd8.jpg";